// Copyright © Orpyx® Medical Technologies Inc. 2026. All rights reserved.
// **ORPYX TRADE SECRET**
// **WARNING**: The contents of this repository, including source code and assets, are confidential. This source code and/or derived works are a trade secret of Orpyx Medical Technologies Inc. Unauthorized disclosure is strictly prohibited and may result in serious legal consequences.

import {createSelector} from "reselect";
import {getPatientsState} from "../../../store/patients.selectors";

export class PatientInformationActionRequiredAlertsSelectors {
    static readonly state = createSelector(getPatientsState, state => state.information.actionRequiredAlerts);

    static readonly loading = createSelector(PatientInformationActionRequiredAlertsSelectors.state, state => state.loading);
    static readonly error = createSelector(PatientInformationActionRequiredAlertsSelectors.state, state => state.error);

    static readonly selected = createSelector(PatientInformationActionRequiredAlertsSelectors.state, state => state.selected);
    static readonly alerts = createSelector(PatientInformationActionRequiredAlertsSelectors.state, state => state.alerts);

    static readonly hasAlerts = createSelector(PatientInformationActionRequiredAlertsSelectors.alerts, (alerts) => {
        if(!alerts) {
            return null;
        } else if (alerts && alerts.length){
            return true;
        }

        return false;
    });
}